import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { ChromeOnlyGate } from '@/components/browser/ChromeOnlyGate';
import { NotificationCountProvider } from '@/entities/notification/providers';
import { AccessProvider } from '@/entities/user/providers/AccessProvider';
import { queryClient } from '@/library/react/queryClient';
import { ThemeProvider } from '@/providers/ThemeProvider';
import { AppRouter } from '@/router/AppRouter';

/**
 * Main application component with provider hierarchy
 * Provider stack: StrictMode → ChromeOnlyGate → Sentry.ErrorBoundary → QueryClientProvider → BrowserRouter → ThemeProvider → AccessProvider → NotificationCountProvider → AppRouter
 */

export function App() {
  return (
    <React.StrictMode>
      <ChromeOnlyGate>
        <Sentry.ErrorBoundary fallback={<p>Something went wrong. Our team has been notified.</p>}>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <ThemeProvider>
                <AccessProvider>
                  <NotificationCountProvider>
                    <AppRouter />
                  </NotificationCountProvider>
                </AccessProvider>
              </ThemeProvider>
            </BrowserRouter>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </Sentry.ErrorBoundary>
      </ChromeOnlyGate>
    </React.StrictMode>
  );
}
